import React from "react";

const COLORS = ["#5E5CE6", "#10B981", "#F59E0B", "#EF4444", "#6366F1", "#EC4899", "#14B8A6", "#8B5CF6", "#3B82F6", "#F97316"];

export default function Avatar({ name = "?", color, size = 28, className = "" }) {
  const initials = (name || "?").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
  const bg = color || COLORS[(name || "").charCodeAt(0) % COLORS.length];
  return (
    <span
      className={`ky-avatar ${className}`}
      style={{ background: bg, width: size, height: size, fontSize: size * 0.42 }}
    >
      {initials}
    </span>
  );
}
